export default __webpack_public_path__ + "static/media/ticket-inside-box.72249339.png";